import React, { useEffect, useState } from 'react';
import './header.css';
import UserCard from '../../components/user/User';
import { UserInfo } from '../../dto/UserInfo';

function Header() {
  const userInfo: UserInfo = JSON.parse(localStorage.getItem('udbs')!);

  useEffect(() => {
  }, [userInfo])

  if (userInfo.email === process.env.REACT_APP_ADM_MOBILE) {
    userInfo.nome = process.env.REACT_APP_ADM_NOME!
    userInfo.nomeEmpresa = process.env.REACT_APP_ADM_EMPRESA!
  }

  return (
    <header className="App-header">


      <div className="user-info-container">
        <UserCard
          emailUsuario={userInfo.email}
          tipoAgente="Representante"
          idAgente={userInfo.idAgente}
          nomeEmpresa={userInfo.nomeEmpresa}
          nome={userInfo.nome}
        />
      </div>

    </header>
  );
}

export default Header;
